<template>
  <div>
    <footer id="footerLogin" v-if="login">
      <span>
        Consulta nuestro
        <a
            style="color: #004a98 !important; font-weight: 700; text-decoration-line: underline;"
          class="underlineHover"
          href="https://dentalia.com/politica-privacidad/"
          target="_blank"
        >
          aviso de privacidad
        </a>
        en
        <a
            style="color: #004a98 !important; font-weight: 700; text-decoration-line: underline;"
          class="underlineHover"
          href="http://www.dentalia.com/"
          target="_blank"
        >
          dentalia.com
        </a>
      </span>

      <span>. Copyright © 2023 dentalia. Todos los derechos reservados. </span>
    </footer>

    <footer id="footerSistema" v-else>
      <span>
        Consulta nuestro
        <a
          class="underlineHover"
          href="https://dentalia.com/politica-privacidad/"
          target="_blank"
        >
          aviso de privacidad
        </a>
        en
        <a
          class="underlineHover"
          href="http://www.dentalia.com/"
          target="_blank"
        >
          dentalia.com
        </a>
      </span>

      <span>. Copyright © 2023 dentalia. Todos los derechos reservados. </span>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    login: {
      type: Boolean,
    },
  },
};
</script>
<style scoped>
  
 #footerLogin, #footerSistema {
   bottom: 0px;
   width: 100%;
   background-color: rgb(141 198 232);
   text-align: center;
   color: #004a98;
   padding: 5px;
   align-items: center;
   justify-content: center;
   font-weight: 700;
 }
 #footerLogin {
   height: 35px;
   position: fixed;
 }
@media only screen and (max-width: 600px) {
#footerLogin {
 position: fixed !important; 
 height: 100px !important;
}
}
</style>
